import type { SVGProps } from 'react'

interface BiomeIntegrationIconProps extends SVGProps<SVGSVGElement> {}

export function BiomeIntegrationIcon(props: BiomeIntegrationIconProps) {
  return (
    <svg
      id="Camada_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 416 416.33"
      {...props}
      fill="currentColor"
    >
      <path
        className="st1"
        d="M161.93 217.77c6.06-.47 13.19-.21 19.14 1 16.43 3.35 29.64 16.13 45.59 20.07 9.63 2.38 31.77 2.51 31.36 16.67-.31 10.76-14.12 14.16-22.81 13.45-13.03-1.07-27.29-6.17-40.39-7.96-6.09-.37-7.96 7.7-2.56 10.24l41.24 8.43c16.2 1.62 36.36-7.25 35.15-26.16-.07-1.15-.94-3.16-.36-4.02 10.57-7.34 20.58-15.51 31.06-22.96 3.44-2.45 7.56-5.99 11.84-6.49 15.77-1.86 23.22 14.58 12.97 26.64-13.76 16.17-30.56 32.32-45.85 47.15-18.41 17.86-28.58 31.72-57.11 27.13-22.53-3.62-45.17-11.15-67.41-16.26-9.1-.28-19.27 12.13-27.24 16.04-3.37 1.21-7.14.95-9.37-2.09l-36.66-52.67c-3.24-7.08 3.05-10.63 8.03-13.91 6.65-4.38 14.24-8.53 21.21-12.45 14.95-8.4 34.96-20.5 52.16-21.84z"
      />
      <path
        className="st1"
        d="M221.33 135.33c-9.52-.46-19.78-2.33-28.66-5.84-23.69-9.37-34.37-31.02-35.36-55.64-.36-8.92 1.14-10.74 10.18-10.18 8.25.51 19.17 3.25 26.73 6.61 16.71 7.42 27.55 22.69 33.11 39.72.46-.04.53-.49.68-.82 5.65-12.35 9.55-22.79 20.65-31.69 9.88-7.93 27.27-12.8 39.82-13.51 5.4-.3 10.54-.01 10.54 6.85 0 6.5-1.45 14.93-3.12 21.24-7.69 29.03-25.94 39.12-54.45 42.88-1.09.14-7 .39-7.14.92l.02 54.8c20.91 1.78 39.77 17.65 44.86 38L262.52 240c-9.59-11.16-26.06-8.16-38.41-13.6-10.1-4.45-19.74-11.06-30.12-15.55-1.49-.65-5.36-1.69-6.33-2.34-.55-.37-.21-.35 0-.67.95-1.41 3.31-3.49 4.66-4.67 8.01-6.98 18.38-11.57 29-12.5v-55.33z"
      />
    </svg>
  )
}
